exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 400px) {\n.modal-content[data-v-104d555f] {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n}\n", ""]);

// exports
